import { render } from "./turnstile-submit-button.vue?vue&type=template&id=75774162"
import script from "./turnstile-submit-button.vue?vue&type=script&lang=js"
export * from "./turnstile-submit-button.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__